"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webix_jet_1 = require("webix-jet");
class Aide extends webix_jet_1.JetView {
    config() {
        return {
            view: "window",
            head: "Aide sur l'application de gestion",
            move: true, position: "center",
            height: 550,
            width: 600,
            close: true, resize: true,
            body: {
                view: "iframe",
                id: "frame-body",
            }
        };
    }
    constructor(app, config) {
        super(app, config);
    }
    showHelp() {
        // @ts-ignore
        this.getRoot().show();
    }
    hideHelp() {
        // @ts-ignore
        this.getRoot().hide();
    }
    load(optionMenu) {
        // @ts-ignore
        $$("frame-body").load(helpPath + optionMenu);
    }
}
exports.default = Aide;
